import React from 'react';

import Footer from '../components/Footer';

import dayjs from 'dayjs';

const FooterEnonic = (props: any) => {
    const newProps = { ...props };

    newProps.copyright = [
        {
            text: 'Copyright © Jotron ',
            year: dayjs().format('YYYY')
        }
    ]

    return <Footer {...newProps} />;
}

export default FooterEnonic;
